<script>
    import { onMount } from "svelte";
    import IconAdd from "../icons/IconAdd.svelte";
    import { LocationStore, Authentication } from '../stores'
	import Location from "./Location.svelte"
	import LocationCru from "./LocationCru.svelte"
    
    let locationFromApi = [];
    let authenthicationData = '';
    let modal;
    let editSelectedLocation;

	onMount(async function () {
        loadLocations();
    });

    async function loadLocations() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/location';

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        // Put the data in the store
        LocationStore.set(data);
        LocationStore.subscribe((data) => locationFromApi = data)
    }

    function addCheeseType() {
        editSelectedLocation = {id: 0, name: '', description: '', levels: 0, levelPositions: 0};
        modal.show();
    }

    function editLocation(editedLocation) {
        editSelectedLocation = editedLocation.detail.editedLocationItem;
        modal.show();
    }
</script>

<nav>
    <ul>
        <li><h1>Standorte/Räume</h1></li>
        <li><IconAdd on:clicked={addCheeseType}/></li>
    </ul>
</nav>

<LocationCru bind:this={modal} location={editSelectedLocation} on:accepted={loadLocations}/>

<div>
    {#each locationFromApi as location}
        <Location location={location} on:customerDeleted={loadLocations} on:editLocation={(editedLocation) => editLocation(editedLocation)}/>
    {/each}
</div>

<style>
    h1 {
        margin-left: -30px;
    }
    
    ul {
        display: flex;
        justify-content: flex;
        list-style: none;
        align-items: center;
    }

    li {
        display: block;
        margin-right: 1em;
    }

    nav {
        margin-top: -70px;
        margin-bottom: -20px;
    }
</style>